module.exports = __webpack_public_path__ + "img/image13.41d5276b.png";